import { useEffect, useState } from 'react';
import productPhotoInitials from './productPhotoInitials';

interface ProductPhotoMarkProps {
    name?: string;
    src?: string;
    large?: boolean;
    onClick?: () => void;
}

const ProductPhotoMark = ({ name, src, large, onClick }: ProductPhotoMarkProps) => {
    const [failed, setFailed] = useState(false);
    const url = String(src || '').trim();
    const showImage = Boolean(url) && !failed;
    const className = `product-photo${large ? ' product-photo--card' : ''}${onClick ? ' cursor-pointer' : ''}`;

    useEffect(() => {
        setFailed(false);
    }, [url]);

    const handleClick = onClick
        ? (event: { stopPropagation: () => void }) => {
              event.stopPropagation();
              onClick();
          }
        : undefined;

    if (showImage) {
        return (
            <img
                src={url}
                alt=""
                className={className}
                onError={() => setFailed(true)}
                onClick={handleClick}
                role={onClick ? 'button' : undefined}
            />
        );
    }

    return (
        <span
            className={`${className} fw-medium`}
            onClick={handleClick}
            role={onClick ? 'button' : undefined}
        >
            {productPhotoInitials(name)}
        </span>
    );
};

export default ProductPhotoMark;
